import React, { useEffect } from 'react'
import Lottie from "lottie-react";
import animationData from "../../utils/loading.json";

const Loading = () => {

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div className='fixed inset-0 bg-white z-[20000] text-black flex-center h-screen w-full flex-col gap-3'>
      <div style={{ width: 300, height: 300 }}>
        <Lottie animationData={animationData} loop={true} />
      </div>
    </div>
  )
}

export default Loading
